import React from 'react';
import { FaBoxOpen, FaClipboardList, FaSignOutAlt, FaStore, FaUser } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import {logout, } from "../../../redux/slices/authSlice";
import {clearCart} from "../../../redux/slices/cartSlice";
import {User, Shirt, Package, Store, LogOut, Undo2, LayoutDashboard, Users} from "lucide-react";

const AdminSidebar = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleLogout = () => {
        dispatch(logout());
        dispatch(clearCart());
        navigate("/");
    };

  return (
    <div className="p-6">
        <div className="mb-6 text-center">
            <Link to="/admin" className="text-2xl font-medium">
                <img 
                    src="https://res.cloudinary.com/dmrlotfsv/image/upload/v1754111081/VESHH-EON_TYPE_WHITE_f3gm0u.png" 
                    alt="VESHH-EON"
                />
            </Link>
        </div>
        <h2 className="text-xl font-medium mb-6 text-center">Admin Dashboard</h2>
        <nav className="flex flex-col space-y-2">

            <NavLink 
                to="/admin" 
                end
                className={({isActive}) => isActive ? "bg-gray-700 text-white py-3 px-4 rounded flex items-center space-x-2" : "text-gray-300 hover:bg-gray-700 hover:text-white py-3 px-4 rounded flex items-center space-x-2"}
            >
                <LayoutDashboard className="w-5 h-5" />
                <span>Overview</span>
            </NavLink>

            <NavLink 
                to="/admin/vendors" 
                className={({isActive}) => isActive ? "bg-gray-700 text-white py-3 px-4 rounded flex items-center space-x-2" : "text-gray-300 hover:bg-gray-700 hover:text-white py-3 px-4 rounded flex items-center space-x-2"}
            >
                <Users className="w-5 h-5" />
                <span>Vendors</span>
            </NavLink>

            <NavLink 
                to="/admin/orders" 
                className={({isActive}) => isActive ? "bg-gray-700 text-white py-3 px-4 rounded flex items-center space-x-2" : "text-gray-300 hover:bg-gray-700 hover:text-white py-3 px-4 rounded flex items-center space-x-2"}
            >
                <Package className="w-5 h-5" />
                <span>Orders</span>
            </NavLink>

            <NavLink 
                to="/admin/returns" 
                className={({isActive}) => isActive ? "bg-gray-700 text-white py-3 px-4 rounded flex items-center space-x-2" : "text-gray-300 hover:bg-gray-700 hover:text-white py-3 px-4 rounded flex items-center space-x-2"}
            >
                <Undo2 className="w-5 h-5" />
                <span>Returns</span>
            </NavLink>
            
            <NavLink 
                to="/admin/users" 
                className={({isActive}) => isActive ? "bg-gray-700 text-white py-3 px-4 rounded flex items-center space-x-2" : "text-gray-300 hover:bg-gray-700 hover:text-white py-3 px-4 rounded flex items-center space-x-2"}
            >
                <User className="w-5 h-5" />
                <span>Users</span>
            </NavLink>

            <NavLink 
                to="/admin/products" 
                className={({isActive}) => isActive ? "bg-gray-700 text-white py-3 px-4 rounded flex items-center space-x-2" : "text-gray-300 hover:bg-gray-700 hover:text-white py-3 px-4 rounded flex items-center space-x-2"}
            >
                <Shirt className="w-5 h-5" />
                <span>Products</span>
            </NavLink>

            <div className="mt-6">
                <button 
                    onClick={handleLogout} 
                    className="w-full bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded flex items-center justify-center space-x-2"
                >
                    <LogOut className="w-5 h-5" />
                    <span>Logout</span>
                </button>
            </div>
        </nav>
    </div>
  )
}

export default AdminSidebar;
